var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnvelope = function SvgEnvelope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3F465A",
    d: "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V2a1 1 0 0 0-1-1zm13 2.383-4.708 2.825L15 9.105zm-.034 6.876-5.64-3.471L8 7.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 11h12a1 1 0 0 0 .966-.741M1 9.105l4.708-2.897L1 3.383z"
  })));
};
export default SvgEnvelope;